const cols = [
  {
    title: "内容版块",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "深扒精选", href: "#featured" },
      { label: "专题合集", href: "#collections" },
      { label: "栏目分类", href: "#categories" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "深度解读", href: "#deep" },
      { label: "常见问题", href: "#faq" },
      { label: "关于本站", href: "#about" },
      { label: "联系反馈", href: "#contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100/80">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">每日黑料</span>
                <span className="mt-1 text-[10px] tracking-[0.3em] text-background-200/50">HOT PICS DAILY</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/70">
              娱乐与舆论热点的内容聚合门户。以时间线与多方核对的方式整理来龙去脉，少一点以讹传讹，多一点可查证的耐心。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#contact"
                  aria-label="关注我们"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h3 className="text-sm font-semibold uppercase tracking-widest text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="inline-flex items-center gap-2 text-sm text-background-200/75 transition-colors hover:text-accent-300">
                      <i className="ri-arrow-right-s-line text-accent-500"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6 text-xs leading-relaxed text-background-200/50">
          <p>
            声明：本站内容为娱乐与舆论话题的编辑性整理与复盘，属于观点与信息聚合性质，不构成对任何组织或个人的评价结论。
            内容所涉话题请以权威渠道与官方信息为准；如涉及权益问题，欢迎通过「联系反馈」告知，我们将及时处理。
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 text-xs text-background-200/60 sm:flex-row">
          <p>© {new Date().getFullYear()} 每日黑料 · 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-line"></i> contact@meiribilei.example
          </p>
        </div>
      </div>
    </footer>
  );
}